<script>
import {getFromData} from '../helpers.js';

export default {
  methods: {
    get(path) {
      return getFromData(this.$store, path);
    },

    getValue(path) {
      return this.get(path + '.value');
    },

    getText(item) {
      let text = '';

      if(typeof item === 'string') text = this.get(item);
      else text = text.text;

      if(this.stringIsEmpty(text)) return '';

      if(this.stringIsEmpty(text)) return '';
      if(typeof text === 'string') return text.replace(/<\/?[^>]+(>|$)/g, '');

      return text.text.replace(/<\/?[^>]+(>|$)/g, '') || '';
    },

    mediaIsEmpty(item) {
      if (typeof item === 'object' && item['video'] !== '' && item['video'] !== null) {
        return item['video'] === '//';
      }

      if (typeof item === 'string' && item !== '' && item !== null) {
        return item === '//';
      }
    },

    mediaIsNotEmpty(item) {
      return !this.mediaIsEmpty(item);
    },

    stringIsEmpty(item) {
      let text = '';

      if(item === null || item === '') return true;

      if (typeof item === 'object' && !!item.text && !item.useConditionalTexts && !!item.conditionalTexts) {
        text = item.text;
      } else {
        text = item;
      }

      if(text === null) return true;
      if(typeof text !== 'string') return false;

      const array = text.split('<');

      /*
       * We use 4 because when we explode the string, if it's a single empty break,
       * so for example, <p class="break-parent-hidden"><br class="break-hidden"></p>,
       * it will never return more than 4 items in the array.
       *
       * This is because it counts the 3 '<' characters the string contains, and the explode()
       * function returns an empty value as first item because the separator is the first
       * character of the string and a blank string value is a valid value.
      */
      if(array.length <= 4) {
        let parentHidden = false;
        for(const item of array) {
          if(item.includes('break-parent-hidden')) {
            parentHidden = true;
            continue;
          }

          if(parentHidden && item.includes('break-hidden')) {
            return true;
          }
        }
      }

      return false;
    },

    stringIsNotEmpty(item) {
      return !this.stringIsEmpty(item);
    },

    getFontFamily(data) {
      const item = data;

      if(item === null) return '';
      if(item.startsWith('google---')) return item.split('---')[1];
      if(item.startsWith('zoe---')) return `${item.split('---')[1]}, ${item}`;

      return item;
    },

    getIconUrl(path) {
      const item = this.get(path);

      if(item === null) return '';
      if(typeof item !== 'object') return '';
      if(!item.itemId) return '';

      const colors = Object.keys(item.colors).map(function (key, value) { return [key, value].join('='); }).join(',');
      return `${this.$store.state.page.domain}/icon/${item.itemId}?colors=${colors}`;
    },

    async getImageSize(item) {
      const image = new Image();
      image.src = item;

      return await new Promise((resolve) => {
        image.onload = () => {
          const dimensions = {
            width: image.width,
            height: image.height,
          };

          resolve(dimensions);
        };
      });
    },
  },
};
</script>
